import React from "react";
const CheckCircle = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M58.6664 29.547V32.0003C58.6631 37.7507 56.801 43.3461 53.3579 47.9518C49.9148 52.5576 45.0751 55.9269 39.5606 57.5574C34.0462 59.1878 28.1524 58.992 22.7583 56.9992C17.3642 55.0063 12.7588 51.3232 9.6289 46.4991C6.49905 41.675 5.01245 35.9685 5.39081 30.2305C5.76917 24.4925 7.99223 19.0305 11.7284 14.6592C15.4646 10.2878 20.5138 7.24131 26.1228 5.97401C31.7319 4.70672 37.6004 5.28652 42.853 7.62696"
            stroke="currentcolor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M58.6667 10.667L32 37.3603L24 29.3603"
            stroke="currentcolor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default CheckCircle;
